// extracted by mini-css-extract-plugin
export default {"formControlLabel":"styles_formControlLabel__drF1Q"};